import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ScenariosSection from './components/ScenariosSection';
import ProductsSection from './components/ProductsSection';
import PartnersSection from './components/PartnersSection';

export default function ArmCloudPage() {
  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ScenariosSection />
        <ProductsSection />
        <PartnersSection />
      </main>
      <Footer />
    </div>
  );
}
